import enCompanyStructure from './en';
import ruCompanyStructure from './ru';

export default {
  en: {
    ...enCompanyStructure,
  },
  ru: {
    ...ruCompanyStructure,
  },
};
